import styled from 'styled-components';

export const Root = styled.div`
  padding-top: 80px;
  width: 100%;
  height: 100%;
  background: #0c0c0c;
`;

export const SectionContainer = styled.div`
  max-width: 1280px;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 80px);
  padding-left: 20px;
  padding-right: 20px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  @media screen and (max-width: 768px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const ProfileImg = styled.img`
  display: block;
  width: 250px;
  height: 250px;
  margin-right: 24px;
`;

export const HeroH1 = styled.h1`
  color: #04d9ff;
  font-size: 64px;
  margin: 0;
  padding: 0;

  @media screen and (max-width: 768px) {
    font-size: 64px;
  }

  @media screen and (max-width: 480px) {
    font-size: 58px;
  }
`;

export const HeroH2 = styled.h2`
  color: #fff;
  font-size: 28px;
  font-weight: 400;
  margin: -12px 0 0;
  padding: 0;

  @media screen and (max-width: 768px) {
    font-size: 30px;
  }

  @media screen and (max-width: 480px) {
    font-size: 24px;
  }
`;

export const HeroP = styled.p`
  color: #fff;
  font-size: 18px;
  margin-top: 12px;

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }

  @media screen and (max-width: 480px) {
    font-size: 16px;
  }
`;

export const IconsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 24px;
`;

export const SocialIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;

  > svg {
    width: 100%;
    height: 100%;
    color: #fff;

    &:hover {
      color: #04d9ff;
    }
  }
`;

export const Flex = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const Tags = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 18px 12px;
`;

export const Tag = styled.h2`
  font-size: 0.8rem;
  color: #fff;
  white-space: nowrap;
  background: transparent;
  border: 1px solid #fff;
  border-radius: 999px;
  padding: 8px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;
